<template>
  <div>
    <b-table
      :data="results"
      paginated
      backend-pagination
      @page-change="onPageChange"
      :total="total"
      :per-page="pageSize"
    >
      <template slot-scope="props">
        <b-table-column field="idSstItem" label="Gutschein" centered>
          {{ props.row.idSstItem }}
        </b-table-column>
        <b-table-column field="dateSold" label="Verkauft am" centered>
          {{ props.row.dateSold | formatDate }}
        </b-table-column>
        <b-table-column field="datePaid" label="Bezahlt am" centered>
          {{ props.row.datePaid | formatDate }}
        </b-table-column>
        <b-table-column field="dateStorno" label="Storniert am" centered>
          {{ props.row.dateStorno | formatDate }}
        </b-table-column>
        <b-table-column label="Hotel" field="hotel">
          {{ props.row.hotel }}
        </b-table-column>
        <b-table-column label="Angebot" field="angebot">
          {{ props.row.angebot }}
        </b-table-column>
        <b-table-column label="Kunde">
          {{ props.row.firstname }} {{ props.row.lastname }}
        </b-table-column>
        <b-table-column label="PLZ">
          {{ props.row.zipCode }}
        </b-table-column>
        <b-table-column label="Kunden E-Mail">
          {{ props.row.email }}
        </b-table-column>
        <b-table-column label="Zustand">
          {{ props.row.state }}
        </b-table-column>
        <b-table-column label="Gruppe">
          {{ props.row.group }}
        </b-table-column>
        <b-table-column label="Währung">
          {{ props.row.currency }}
        </b-table-column>
        <b-table-column label="Stück">
          {{ props.row.quantity }}
        </b-table-column>
        <b-table-column label="Umsatz">
          {{ props.row.currency | currency }}
          {{ props.row.totalAmount | amount }}
        </b-table-column>
        <b-table-column label="Provision">
          {{ props.row.currency | currency }}
          {{ props.row.comission | amount }}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'ComissionTable',
  props: {
    results: Array,
    page: Number,
    pageSize: Number,
    total: Number,
  },
  methods: {
    onPageChange(p) {
      this.$emit('request-page', p)
    },
  },
}
</script>
